import { useMediaQuery } from '@mui/material'
import { useMemo } from 'react'

export const useMediaQueries = () => {
  const isLargeScreenQuery = useMediaQuery('(min-width:1024px)')
  const isMediumScreenQuery = useMediaQuery('(min-width:640px)')
  const isSmallScreenQuery = useMediaQuery('(max-width:639px)')

  const screenSizes = useMemo(() => {
    const isDesktop = isLargeScreenQuery
    const isTablet = isMediumScreenQuery && !isLargeScreenQuery
    const isMobile = isSmallScreenQuery
    const isDesktopOrTablet = isDesktop || isTablet
    const isMobileOrTablet = isMobile || isTablet

    return {
      isDesktop,
      isTablet,
      isMobile,
      isDesktopOrTablet,
      isMobileOrTablet,
    }
  }, [isLargeScreenQuery, isMediumScreenQuery, isSmallScreenQuery])

  return screenSizes
}
